import { JsonSerializable } from '../shared/jsonSerializable';
import { RequestStatus } from '../entity/request-status';
import { RequestIncident } from '../entity/request-incident';
import { Du } from '../entity/du';
import { Package } from '../entity/package';
import * as moment from 'moment/moment';

export class ResultDu extends JsonSerializable {
  billingCode: string;
  billingDate: string;
  clientResultDuStatus: RequestStatus;
  clientResultDuIncident: RequestIncident;
  numericValue: number;
  textValue: string;
  reserve: string;
  norm: string;
  cofrac: boolean;
  signatory: string;
  calculationExcluded: boolean;
  validationDate: moment.Moment;
  unit: string;
  isBilled: boolean;
  du: Du;
  limsResultDuStatus: RequestStatus;
  package: Package;

  constructor() {
    super();
    this.billingCode = null;
    this.billingDate = null;
    this.clientResultDuStatus = null;
    this.numericValue = null;
    this.cofrac = false;
    this.du = null;
    this.isBilled = false;
    this.limsResultDuStatus = null;
    this.norm = null;
    this.reserve = null;
    this.signatory = null;
    this.textValue = null;
    this.unit = null;
    this.validationDate = null;
    this.package = null;
    this.calculationExcluded = false;
  }


  fromJSON(jsonObj: Object) {
    for (var propName in jsonObj) {
      if (this.hasOwnProperty(propName)) {
        if(jsonObj[propName] instanceof Object){
          if (propName == "du") {
            this[propName] = new Du();
          } else if (propName == "package") {
            this[propName] = new Package();
          } else if (propName == "clientResultDuStatus" || propName == "limsResultDuStatus") {
            this[propName] = new RequestStatus();
          } else if (propName == "clientResultDuIncident" || propName == "limsResultDuIncident") {
            this[propName] = new RequestIncident();
          }
          this[propName].fromJSON(jsonObj[propName]);
        } else if ((propName=="validationDate") && moment(jsonObj[propName]).isValid()) {
          this[propName] = moment(jsonObj[propName]);
        } else {
          this[propName] = jsonObj[propName];
        }
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/entity/result-du.ts